import {
  CONNECT_USER,
  CONNECT_SUCCESS,
  SET_AGENT,
  BOT_BLINK,
  AGENT_BLINK,
} from '../actions';

export const ConnectUser = () => ({
  type: CONNECT_USER,
});

export const SetAgent = (isAgent) => ({
  type: SET_AGENT,
  payload: isAgent,
});

export const BotBlink = (blink) => ({
  type: BOT_BLINK,
  payload: blink,
});

export const AgentBlink = (blink) => ({
  type: AGENT_BLINK,
  payload: blink,
});

export const ConnectSuccess = (connection) => ({
  type: CONNECT_SUCCESS,
  payload: connection,
});
